import { render, staticRenderFns } from "./CustomerBasicForm.vue?vue&type=template&id=be13a076&"
import script from "./CustomerBasicForm.vue?vue&type=script&lang=js&"
export * from "./CustomerBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports